/**
 * @Author: Haojun.Cao
 * @Date: 2023/1/4 16:28
 */
export const scriptFn =async() => {
  const url = '//glswdl-ps.test.geely.com/fuseboxjson/vehicle.json';
  // const script=new Image();
  const script = document.createElement('script');
 // script.type = 'application\/json';
  script.src = url;
  script.onload = e => {
    console.log(script, e);
    for (const key in script) {
      console.log(key,'=====',script[key]);
    }
  };

  (document.head || document.getElementsByTagName('head')[0]).append(script);
};





// WEBPACK FOOTER //
// ./src/utils/getJSON.js